import en from 'vee-validate/dist/locale/en.json';

export default {
  messages: {
    ...en.messages,
    txHash: "Transaction hash is invalid",
    IPV4_6: "IP address is invalid",
    required: "The field is required",
    confirmed: "The field does not match",
    txAddress: "Address is invalid",
  },
  names: {
    email: "email",
    password: "Password",
  },
  fields: {
    password: {
      min: "{_field_} is too short, you want to get hacked?",
    },
  },
};
